var ifc_ajax_retry = require('./ifc-ajax-retry');
const {floatval} = require("locutus/php/var");

function braintree_init(fetch_client_token_url,
                        paypal_env,
                        hosted_fields_styles_object,
                        hosted_fields_number_selector,
                        hosted_fields_cvv_selector,
                        hosted_fields_exp_selector,
                        hosted_fields_post_code_selector,
                        paypal_button_selector,
                        paypal_button_styles_object,
                        // callbacks
                        knockout_subscribable_total_price_function,
                        client_recoverable_error_callback,
                        client_unrecoverable_error_callback,
                        payments_are_ready_callback,
                        payment_is_currently_processing_true_false_callback,
                        nonce_received_callback,
                        credit_card_submit_event,
                        pppin4_selector,
                        should_show_ppin4_stuff_callback
) {
    var self = this;

    // payment requirements
    self.braintree = {};
    self.braintree.client = require('braintree-web/client');
    self.braintree.hostedFields = require('braintree-web/hosted-fields');
    self.braintree.paypalCheckout = require('braintree-web/paypal-checkout');

    self.n_payment_methods = 2;
    self.n_payment_methods_initialized = 0;
    self.payment_method_initialization_complete_callback = function () {
        self.n_payment_methods_initialized++;
        console.log(sprintf('%d payment methods now initialized', self.n_payment_methods_initialized));
        if (self.n_payment_methods === self.n_payment_methods_initialized) {
            console.log('payment methods are ready');
            payments_are_ready_callback(true);
        }
    };
    self.hosted_fields_instance = null;
    // LEVEL 0
    // LEVEL 0
    // LEVEL 0
    // Get token URL from client
    ifc_ajax_retry('GET',
        'text', function () {
            return fetch_client_token_url;
        }, 5,
        null,
        client_recoverable_error_callback,
        client_unrecoverable_error_callback,
        function (braintree_client_token) {
            console.log(sprintf('Braintree token fetch success: %s', braintree_client_token));

            self.braintree.client.create({
                    authorization: braintree_client_token,
                    locale: 'en_US'
                },

                // LEVEL 1
                // LEVEL 1
                // LEVEL 1
                // Braintree Overarching Client Init
                function (clientErr, clientInstance) {
                    if (clientErr) {
                        client_unrecoverable_error_callback(clientErr);
                        return;
                    }

                    console.log("braintree client create success");
                    console.log(clientInstance);
                    // Braintree Client is Created
                    // LEVEL 2
                    // LEVEL 2
                    // LEVEL 2
                    // Hosted Fields Init
                    self.braintree.hostedFields.create({
                            client: clientInstance,
                            styles: hosted_fields_styles_object,
                            fields: {
                                number: {
                                    selector: hosted_fields_number_selector
                                },
                                cvv: {
                                    selector: hosted_fields_cvv_selector,
                                    placeholder: '•••'
                                },
                                expirationDate: {
                                    selector: hosted_fields_exp_selector
                                },
                                postalCode: {
                                    selector: hosted_fields_post_code_selector
                                }
                            }
                        },

                        // LEVEL 3
                        // LEVEL 3
                        // LEVEL 3
                        // Hosted Fields Creation Success Callback
                        function (hostedFieldsErr, hostedFieldsInstance) {
                            if (hostedFieldsErr) {
                                client_unrecoverable_error_callback(hostedFieldsErr);
                                return;
                            }

                            console.log('hosted fields creation success');
                            console.log(hostedFieldsInstance);

                            self.payment_method_initialization_complete_callback(hostedFieldsInstance);
                            self.hosted_fields_instance = hostedFieldsInstance;
                        });

                    // LEVEL 2
                    // LEVEL 2
                    // LEVEL 2
                    // Paypal Checkout Init
                    self.braintree.paypalCheckout.create({
                        client: clientInstance
                    }, function (paypalCheckoutError, paypalCheckoutInstance) {
                        if (paypalCheckoutError) {
                            client_unrecoverable_error_callback(paypalCheckoutError);
                            return;
                        }

                        console.log('braintree paypalCheckout object is created');
                        console.log(paypalCheckoutInstance);
                        // LEVEL 3
                        // LEVEL 3
                        // LEVEL 3

                        let prettyAmount = function () {
                            let amt = number_format(knockout_subscribable_total_price_function(), 2, '.', '');
                            console.log("calling prettyAmount", amt);
                            return amt;
                        };
                        let ppSDKOpts = {
                            components: 'buttons,messages',
                            intent: 'capture', // Braintree defaults this to 'authorize'
                            currency: 'USD',
                            'enable-funding': 'paylater',
                            dataAttributes: {
                                amount: prettyAmount()
                            },
                            commit: true,
                            vault: false,
                        };
                        let getPpPaymentOpts = function() {
                            return {
                                flow: 'checkout', // Required
                                amount: prettyAmount(), // Required
                                currency: 'USD', // Required
                                intent: 'capture',
                                enableShippingAddress: false
                            };
                        }
                        /**
                         * This will update the paypal component to reflect the correct amount when the
                         * price changes. This relies on the fact (which was previously an implementation
                         * detail) that I am passing down a knockout object here.
                         */
                        knockout_subscribable_total_price_function.subscribe(function(tp){
                            paypalCheckoutInstance.updatePayment(getPpPaymentOpts());
                        });

                        //console.log(ppSDKOpts);
                        paypalCheckoutInstance.loadPayPalSDK(ppSDKOpts, function (loadPayPalSDKErr) {
                            // Adds https://www.paypal.com/sdk/js script to the page and
                            // adds the paypal object to the window
                            // LEVEL 4
                            // LEVEL 4
                            // LEVEL 4
                            // Paypal SDK is now initialized

                            if (loadPayPalSDKErr) {
                                client_unrecoverable_error_callback(loadPayPalSDKErr);
                                return;
                            }

                            let onApprove = function (data, actions) {
                                return paypalCheckoutInstance.tokenizePayment(data)
                                    .then(function (payload) {
                                        console.log(sprintf('paypal braintree nonce received [%s]', payload.nonce));
                                        nonce_received_callback(payload.nonce);
                                    });
                            };

                            let onCancel = function (data) {
                                console.log('client canceled payment');
                                client_recoverable_error_callback("You cancelled your payment.");
                            };

                            let createPayment = function () {
                                return paypalCheckoutInstance.createPayment(getPpPaymentOpts());
                            };

                            let onError = function (err) {
                                client_recoverable_error_callback(
                                    sprintf("There was an error processing your payment. <pre>%s</pre>",
                                        print_r(err, true)));

                                console.error('checkout.js error', err);
                            };

                            // Paypal Configuration and Button Creation
                            let standardBtn = paypal.Buttons({
                                fundingSource: paypal.FUNDING.PAYPAL,
                                style: paypal_button_styles_object,
                                env: paypal_env, // or 'sandbox'
                                createOrder: createPayment,
                                onApprove: onApprove,
                                onCancel: onCancel,
                                onError: onError
                            })

                            if (standardBtn.isEligible()) {
                                standardBtn.render(paypal_button_selector).then(function () {
                                    // The PayPal button will be rendered in an html element with the id
                                    // paypal_button_selector. This function will be called when the PayPal button
                                    // is set up and ready to be used.

                                    console.log("Paypal checkout button created");
                                    self.payment_method_initialization_complete_callback(paypalCheckoutInstance);
                                })
                            }

                            let payLaterBtn = paypal.Buttons({
                                fundingSource: paypal.FUNDING.PAYLATER,
                                env: paypal_env, // or 'sandbox'
                                createOrder: createPayment,
                                onApprove: onApprove,
                                onCancel: onCancel,
                                onError: onError
                            });

                            if (payLaterBtn.isEligible()) {
                                // Skip rendering if not eligible
                                payLaterBtn.render(pppin4_selector);
                                should_show_ppin4_stuff_callback(true);
                            } else {
                                console.log("pppin4 is ineligible");
                                should_show_ppin4_stuff_callback(false);
                            }
                        });
                    });
                }
            );
        });


    $(document).bind(credit_card_submit_event, function () {
        braintree_credit_card_submit(self.hosted_fields_instance,
            client_recoverable_error_callback,
            payment_is_currently_processing_true_false_callback,
            nonce_received_callback);
    });

}


function braintree_credit_card_submit(hosted_fields_instance,
                                      client_recoverable_error_function,
                                      payment_is_currently_processing_true_false_callback,
                                      card_submit_did_succeed_with_nonce_callback) {

    console.log('braintree credit payment out for processing');
    payment_is_currently_processing_true_false_callback(true);
    hosted_fields_instance.tokenize(function (tokenizeErr, payload) {
        // from https://braintree.github.io/braintree-web/3.22.2/HostedFields.html#tokenize
        if (tokenizeErr) {
            console.log('braintree tokenization error');
            console.log(tokenizeErr.code);
            console.log(tokenizeErr);
            switch (tokenizeErr.code) {
                case 'HOSTED_FIELDS_FIELDS_EMPTY':
                    // occurs when none of the fields are filled in
                    client_recoverable_error_function('All credit card fields are empty! Please fill out the form.');
                    break;
                case 'HOSTED_FIELDS_FIELDS_INVALID':
                    // occurs when certain fields do not pass client side validation
                    client_recoverable_error_function(sprintf('Some credit card fields are invalid: [%s]. Please fill them out before continuing.', tokenizeErr.details.invalidFieldKeys));
                    break;
                case 'HOSTED_FIELDS_TOKENIZATION_FAIL_ON_DUPLICATE':
                    // occurs when:
                    //   * the client token used for client authorization was generated
                    //     with a customer ID and the fail on duplicate payment method
                    //     option is set to true
                    //   * the card being tokenized has previously been vaulted (with any customer)
                    // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.fail_on_duplicate_payment_method
                    client_recoverable_error_function('This payment method is in use elsewhere. Please try another payment method.');
                    break;
                case 'HOSTED_FIELDS_TOKENIZATION_CVV_VERIFICATION_FAILED':
                    // occurs when:
                    //   * the client token used for client authorization was generated
                    //     with a customer ID and the verify card option is set to true
                    //     and you have credit card verification turned on in the Braintree
                    //     control panel
                    //   * the cvv does not pass verfication (https://developers.braintreepayments.com/reference/general/testing/#avs-and-cvv/cid-responses)
                    // See: https://developers.braintreepayments.com/reference/request/client-token/generate/#options.verify_card
                    client_recoverable_error_function('Credit Card CVV code did not pass verification');
                    break;
                case 'HOSTED_FIELDS_FAILED_TOKENIZATION':
                    // occurs for any other tokenization error on the server
                    client_recoverable_error_function('We could not verify your card. Would you please check your data and try again?');
                    break;
                case 'HOSTED_FIELDS_TOKENIZATION_NETWORK_ERROR':
                    // occurs when the Braintree gateway cannot be contacted
                    client_recoverable_error_function('There was a network error while trying to verify your card. Would you please check your network connection and try again? ');
                    break;
                default:
                    client_recoverable_error_function(sprintf('An unidentified error occurred while processing your card. Please verify your data and try again. ["%s": "%s"]', tokenizeErr.code, tokenizeErr.message));
            }

            payment_is_currently_processing_true_false_callback(false);
            return;
        }

        console.log(sprintf('braintree credit card nonce received [%s]', payload.nonce));
        payment_is_currently_processing_true_false_callback(false);
        card_submit_did_succeed_with_nonce_callback(payload.nonce);
    });

}

module.exports = {braintree_init: braintree_init};
